import React, { useState, useEffect } from 'react';
import { Modal, Form, Table, Alert, Spinner } from 'react-bootstrap';
import RendicontazioneAdminService from '../../services/RendicontazioneAdminService/RendicontazioneAdminService';

const ANNO_INIZIO = 2025;

export default function LiquidazioneAnnualeModal({ show, onHide, superpartner }) {
    const currentYear = new Date().getFullYear();
    const [anno, setAnno] = useState(currentYear);
    const [riepilogo, setRiepilogo] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const anniOptions = [];
    for (let y = ANNO_INIZIO; y <= currentYear; y++) {
        anniOptions.push(y);
    }

    useEffect(() => {
        if (!show || !superpartner?.id_superpartner || !anno) {
            setRiepilogo(null);
            return;
        }
        let cancelled = false;
        setLoading(true);
        setError(null);
        RendicontazioneAdminService.getRiepilogoLiquidazioneAnnuale(superpartner.id_superpartner, anno)
            .then((data) => {
                if (!cancelled) setRiepilogo(data || null);
            })
            .catch((err) => {
                if (!cancelled) {
                    setError(err?.message || 'Errore nel caricamento della liquidazione annuale.');
                    setRiepilogo(null);
                }
            })
            .finally(() => {
                if (!cancelled) setLoading(false);
            });
        return () => { cancelled = true; };
    }, [show, superpartner?.id_superpartner, anno]);

    const corsi = riepilogo?.corsi || [];

    return (
        <Modal show={show} onHide={onHide} size="lg" centered>
            <Modal.Header closeButton>
                <Modal.Title>Liquidazione annuale – {superpartner?.nome}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form.Group className="mb-3">
                    <Form.Label>Anno</Form.Label>
                    <Form.Select
                        value={anno}
                        onChange={(e) => setAnno(parseInt(e.target.value, 10))}
                        disabled={loading}
                    >
                        {anniOptions.map((y) => (
                            <option key={y} value={y}>{y}</option>
                        ))}
                    </Form.Select>
                </Form.Group>

                {error && <Alert variant="danger">{error}</Alert>}

                {loading ? (
                    <div className="text-center py-4">
                        <Spinner animation="border" size="sm" /> Caricamento...
                    </div>
                ) : (
                    <Table striped bordered hover size="sm" className="mb-4">
                        <thead className="table-light">
                            <tr>
                                <th>Corso</th>
                                <th className="text-end" style={{ width: '180px' }}>Corsi Attivati (anno {anno})</th>
                                <th className="text-end" style={{ width: '180px' }}>Importo</th>
                            </tr>
                        </thead>
                        <tbody>
                            {corsi.length === 0 ? (
                                <tr>
                                    <td colSpan={3} className="text-center text-muted">Nessun corso configurato o nessun dato per l’anno selezionato.</td>
                                </tr>
                            ) : (
                                corsi.map((row) => (
                                    <tr key={row.id_corso}>
                                        <td>{row.etichetta || '-'}</td>
                                        <td className="text-end">{row.totale_corsi ?? 0}</td>
                                        <td className="text-end">€ {(parseFloat(row.importo) || 0).toFixed(2)}</td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                        {corsi.length > 0 && (
                            <tfoot>
                                <tr className="table-light fw-bold">
                                    <td>Totale</td>
                                    <td className="text-end">{riepilogo?.totale_corsi ?? 0}</td>
                                    <td className="text-end">€ {(parseFloat(riepilogo?.totale_importo) || 0).toFixed(2)}</td>
                                </tr>
                            </tfoot>
                        )}
                    </Table>
                )}
            </Modal.Body>
        </Modal>
    );
}
